import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class BN_TreatmentPlanCategoryModality extends BackboneElement {
    static __className = 'BN_TreatmentPlanCategoryModality';

    __objectStructure = {
        modal: String,
        display: String, // Free-text human name for in-app authored theoretical models
        level: [Number], // Array of numbers to support multiple levels
        source: String, // Citations
        sourceHasAsterisk: Boolean,
        reference: String, // Where objectives/interventions were derived from
        referenceHasAsterisk: Boolean,
        narrative: String, // Extra explanatory text that appears before the sources/references
    };

    constructor(constructJson, className = 'BN_TreatmentPlanCategoryModality') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
